import { Box } from "@chakra-ui/react";
import { Trans } from "react-i18next";
import React, { type FormEvent } from "react";
import { Modal } from "@revoo/design-system/ui/Modal/Modal";
import { Header3 } from "@revoo/design-system/ui/Typography/Header3";
import { Text1 } from "@revoo/design-system/ui/Typography/Text1";
import { LinkStyled } from "@revoo/design-system/ui/Typography/LinkStyled";
import { Checkbox } from "@revoo/design-system/ui/Form/Checkbox/Checkbox";
import { Field } from "@revoo/design-system/ui/Form/Field/Field";
import { useFormContext } from "react-hook-form";
import { Button } from "@revoo/design-system/ui/Button/Button";
import { useUpdateFeatureFlagsMutation } from "@/libs/settings/redux/settings.api";
import { useFeatureFlagsContext } from "@/libs/shared/providers/FeatureFlagsProvider";
import { CONTACT_LINK, GDPR_LINK } from "@/libs/shared/constants";

const TermsFlagsModal = () => {
  const { flags: { gdpr } = {}, setIsOpenTerms } = useFeatureFlagsContext();

  const {
    control,
    formState: { isValid },
    handleSubmit,
  } = useFormContext();

  const [updateFlags, { isLoading }] = useUpdateFeatureFlagsMutation();

  return (
    <Modal
      isOpen
      alignContent="center"
      justifyContent="center"
      onClose={() => {}}
      hasClosedButton={false}
      bodyProps={{
        alignContent: "center",
        justifyContent: "center",
      }}
    >
      <Box
        mt={-8}
        mx="auto"
        as="form"
        display="flex"
        flexDirection="column"
        alignContent="center"
        justifyContent="center"
        onSubmit={(event: FormEvent<HTMLFormElement>) => {
          void handleSubmit(updateFlags)(event).then(() => {
            setIsOpenTerms(false);
          });
        }}
        width={{
          base: "100%",
          lg: "lg",
        }}
      >
        {!gdpr && (
          <Box my={8}>
            <Header3
              mb={3}
              fontSize={{
                base: "md",
                sm: "xl",
              }}
            >
              <Trans i18nKey="FeatureFlags:title" />
            </Header3>
            <Text1 mb={4}>
              <Trans i18nKey={"FeatureFlags:description"} />
            </Text1>
            {!gdpr && (
              <Field
                mt={4}
                component={Checkbox}
                control={control as any}
                name="gdpr"
                checkboxLabel={
                  <a
                    target="_blank"
                    href={GDPR_LINK}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <Text1 as="u">
                      <Trans i18nKey="Signup:form:gdpr" />
                    </Text1>
                    {` `}*
                  </a>
                }
              />
            )}
          </Box>
        )}
        <Button
          size="lg"
          type="submit"
          variant="solid"
          isDisabled={!isValid}
          isLoading={isLoading}
        >
          <Trans i18nKey="FeatureFlags:submit" />
        </Button>
        <LinkStyled as="a" mt={4} target="_blank" href={CONTACT_LINK}>
          <Trans i18nKey="FeatureFlags:contact" />
        </LinkStyled>
      </Box>
    </Modal>
  );
};

export default TermsFlagsModal;
